import { useRive } from "@rive-app/react-canvas"
import Processing from "url:/public/assets/ces_2025_processing_delay.riv"

const ProcessingAnimation = () => {
  const { RiveComponent } = useRive({
    src: Processing,
    stateMachines: "processing",
    // layout: new Layout({
    //   fit: Fit.Contain,
    //   alignment: Alignment.Center
    // }),
    autoplay: true,
  })
  return (
    <div
      css={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div css={{ width: 196, height: 196 }}>
        <RiveComponent />
      </div>
    </div>
  )
}

export default ProcessingAnimation
